import React from 'react'
import Navbar from '../components/Navbar'
import MySkills from '../components/MySkills'
import FloatResume from '../components/FloatResume'

const Skills = () => {
  return (
    <div>
      <Navbar />
      <MySkills />
      <FloatResume />
    </div>
  )
}

export default Skills
